import { SignUp } from "./auth/sign-up";
import { SignIn } from "./auth/sign-in";
import { ForgotPassword } from "./auth/forgot-password";
import { OtpVerificationEmail } from "./auth/otp-verification-email";
import { OtpVerificationPhone } from "./auth/otp-verification-phone";
import { ResetPassword } from "./auth/reset-password";
import { ForgotPasswordVerification } from "./auth/forgot-password-otp-verification";
import { NewPassword } from "./auth/new-password";
import { AddBankAccount, UpdateBankAccount } from "./auth/add-bank-account";
import { ProfileSetup, UpdateProfileSetup } from "./auth/profile-setup";
import { StaffList, StaffForm } from "./modules/staff";
import {
  OfferList,
  OfferForm,
  PackageList,
  PackageForm,
  OfferAndPackagesPaymentForm
} from "./modules/offer-and-packages";
import { Dashboard } from "./modules/dashboard";
import { ServicesList, ServicesForm } from "./modules/services";
import { Request } from "./modules/request";
import {
  WalletInfo,
  WalletTransactions,
  WalletInfoPaymentForm,
  GiftCard,
  PurchaseGiftCard,
  GiftCardPaymentForm
} from "./modules/wallet";
import {
  Calendar,
  AppointmentsInfo,
  AppointmentsInfoDetails,
  ServiceInfoList
} from "./modules/appointment";
import { StaffChat, UserChat, ChatRequest } from "./modules/chat";
import {
  CustomerInfo,
  CustomerInfoDetails,
  CustomerInfoAppointmentDetails,
  CustomerInfoDetailsDetails,
  CustomerInfoAppointmentViewDetails
} from "./modules/customer-db/customer-info";
import {
  Subscriptions,
  SubscriptionPaymentForm,
  SubscriptionsPlanHistory,
  ActivePlan,
} from "./modules/subscriptions-and-addons";
import { SendPushNotification, SentPushNotificationList } from "./modules/push-notification";
import { ServiceProviderReviewInfo } from "./modules/service-provider-reviews";
import { HelpAndSupport } from "./modules/help-and-support";

export {
  SignIn,
  SignUp,
  ForgotPassword,
  OtpVerificationEmail,
  OtpVerificationPhone,
  ResetPassword,
  ForgotPasswordVerification,
  NewPassword,
  AddBankAccount,
  UpdateBankAccount,
  Dashboard,
  StaffList,
  StaffForm,
  ServicesList,
  ServicesForm,
  OfferList,
  OfferForm,
  PackageList,
  PackageForm,
  Request,
  ProfileSetup,
  UpdateProfileSetup,
  WalletInfo,
  WalletTransactions,
  Calendar,
  AppointmentsInfo,
  UserChat,
  StaffChat,
  CustomerInfo,
  AppointmentsInfoDetails,
  Subscriptions,
  ChatRequest,
  SubscriptionPaymentForm,
  WalletInfoPaymentForm,
  GiftCard,
  CustomerInfoDetails,
  SubscriptionsPlanHistory,
  ActivePlan,
  OfferAndPackagesPaymentForm,
  PurchaseGiftCard,
  GiftCardPaymentForm,
  ServiceInfoList,
  SendPushNotification, SentPushNotificationList,
  ServiceProviderReviewInfo,
  HelpAndSupport
};
